import { ActivatedRoute } from '@angular/router';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MICROBIOLOGY_DATA_STORAGE } from '../../on-screen-results/microbiology-data/microbiology-data-storage';
import { InvestigatorMicrobiologyStorage } from './investigator-microbiology-storage';
import { Site } from '../../sites';
import { routeSnapshotExtensions } from '../../shared/route-extensions';

@Component({
    selector: 'investigator-microbiology',
    template: require('./investigator-microbiology.component.html'),
    styles: [require('./investigator-microbiology.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {provide: MICROBIOLOGY_DATA_STORAGE, useClass: InvestigatorMicrobiologyStorage}
    ]
})
export class InvestigatorMicrobiologyComponent {
    public siteId: number;

    constructor(route: ActivatedRoute) {
        const site = routeSnapshotExtensions.findData(route.snapshot, 'selectedSite') as Site | null;
        this.siteId = site && site.siteId;
    }
}